import {
  Companion_instance2x6o1nijtl11 as Companion_instance,
  Trade15v4llu79udze as Trade,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get__id(_this__u8e3s4) {
  return _this__u8e3s4.prop(Trade__id_getInstance());
}
function prepareTradeFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [Trade__id_getInstance()];
  var tmp = Companion_instance.m2a();
  properties(tmp, (it) => props);
}
function Trade__id$name$delegate$lambda() {
  return Companion_instance.m2a().az().v11(0);
}
function Trade__id$_get_name_$ref_iyqc4s() {
  return (p0) => p0.k20();
}
function Trade__id$serializer$delegate$lambda() {
  var tmp = Companion_instance.m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Trade__id$_get_serializer_$ref_qz844t() {
  return (p0) => p0.j2j();
}
function Trade__id$annotations$delegate$lambda() {
  return Companion_instance.m2a().az().x11(0);
}
function Trade__id$_get_annotations_$ref_w5262x() {
  return (p0) => p0.bz();
}
var Trade__idClass;
function Trade__id() {
  if (Trade__idClass === VOID) {
    class $ {
      constructor() {
        Trade__id_instance = this;
        var tmp = this;
        tmp.a86_1 = lazy(Trade__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b86_1 = lazy(Trade__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c86_1 = lazy(Trade__id$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.a86_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Trade__id$_get_name_$ref_iyqc4s(), null);
        return tmp0.f2();
      }
      d86(receiver) {
        return receiver.e86_1;
      }
      m2j(receiver) {
        return this.d86(receiver instanceof Trade() ? receiver : THROW_CCE());
      }
      f86(receiver, value) {
        return receiver.p5z(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Trade() ? receiver : THROW_CCE();
        return this.f86(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b86_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Trade__id$_get_serializer_$ref_qz844t(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c86_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Trade__id$_get_annotations_$ref_w5262x(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Trade__id', VOID, VOID, [SerializableProperty()]);
    Trade__idClass = $;
  }
  return Trade__idClass;
}
var Trade__id_instance;
function Trade__id_getInstance() {
  if (Trade__id_instance === VOID)
    new (Trade__id())();
  return Trade__id_instance;
}
//region block: exports
export {
  get__id as get__id1te557a8ur54q,
  prepareTradeFields as prepareTradeFields1xnthf8tnsyqb,
};
//endregion

//# sourceMappingURL=TradeFields.mjs.map
